import * as React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import {PremiumWrapper} from './PremiumWrapper';
export class PremiumWrapperOverlay extends React.Component {
  state = {
    isActive: true,
  };

  render() {
    if (this.props.disabled) {
      return this.props.children;
    } else {
      return (
        <LoadingOverlay
          disabled={this.props.disabled}
          active={this.state.isActive}
          spinner={
            <PremiumWrapper
              bi={this.props.bi}
              broPlanIsRequiredText={
                'BRO plan is required to configure this widget'
              }
              onPremiumChange={(isPremium) =>
                this.setState({isActive: !isPremium})
              }
              from={'premiumUpdate'}
            >
              <></>
            </PremiumWrapper>
          }
        >
          {this.props.children}
        </LoadingOverlay>
      );
    }
  }
}
